"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class contain function related to Runtime Config API
 * @public
 */
class RuntimeConfig extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get runtime config detail
     * @param configKey - Id of config
     * @returns runtime config details
     */
    async getRunTimeConfigDetail(configKey) {
        try {
            const res = await this._apiV2.runtimeConfigAPI.getConfigDetail(configKey);
            return res;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get list micro frontend config
     * @returns list of micro front end config
     */
    async getMicroFEConfig() {
        try {
            const res = await this._apiV2.runtimeConfigAPI.getListMicroFrontendHost();
            return res;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get list runtime config
     * @param key - array of runtime config key to query
     * @param options - query options
     * @returns list of runtime config
     */
    async getRuntimeConfigList(key, options) {
        try {
            const res = await this._apiV2.runtimeConfigAPI.getConfigList(key, options);
            return res;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = RuntimeConfig;
